module.exports = __webpack_public_path__ + "img/notes.a61a97d6.svg";